import { FC } from 'react'
import { useCurrentBusinessUnitsByCompany } from '../../graphql/draft-score-grid/useDraftScoreGrid'
import { LoadingAndErrors } from '../../components/custom_components/LoadingAndErrors'
import { DraftScoreGridsImportModalContent } from './DraftScoreGridsImportModalContent'
import { Country, ScoreGoalDto, BusinessUnitTiny } from '../../types'

type DraftScoreGridsImportModalProps = {
  employeeIdsAndScoreGoals: { employeeId: number; scoreGoals?: ScoreGoalDto[] | null; hasDraft: boolean; bu: BusinessUnitTiny }[]
  scoreGoalTypes: string[]
  companyId: string
  country: Country
  setIsOpened: (value: boolean) => void
}

export const DraftScoreGridsImportModal: FC<DraftScoreGridsImportModalProps> = ({
  employeeIdsAndScoreGoals,
  scoreGoalTypes,
  companyId,
  country,
  setIsOpened,
}) => {
  const { data, error, loading } = useCurrentBusinessUnitsByCompany(companyId, country)
  if (loading || error || !data || !data.findCurrentBusinessUnitsByCompanyId) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data || !data.findCurrentBusinessUnitsByCompanyId} error={error} showSpinner />
  }
  const businessUnitsOfCompany: BusinessUnitTiny[] = data.findCurrentBusinessUnitsByCompanyId

  return (
    <DraftScoreGridsImportModalContent
      employeeIdsAndScoreGoals={employeeIdsAndScoreGoals}
      scoreGoalTypes={scoreGoalTypes}
      companyId={companyId}
      country={country}
      setIsOpened={setIsOpened}
      businessUnitsOfCompany={businessUnitsOfCompany}
    />
  )
}
